export const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
};

export const formatCurrency = (amount, withSymbol = false) => {
    // Sécurise les valeurs undefined/null/NaN
    const number = Number(amount);
    const safe = Number.isFinite(number) ? number : 0;

    // Format avec un espace comme séparateur de milliers
    const parts = safe.toFixed().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const formattedValue = parts.join(',');

    // Ajout du symbole de devise si demandé
    return withSymbol ? formattedValue + ' FCFA' : formattedValue;
};



export const getStatusBadge = (status) => {
    switch (status) {
        case 'PAID':
            return <span className="badge bg-success">Payée</span>;
        case 'PENDING':
            return <span className="badge bg-warning text-dark">En attente</span>;
        case 'OVERDUE':
            return <span className="badge bg-danger">En retard</span>;
        default:
            return <span className="badge bg-secondary">Inconnu</span>;
    }
};
